<template>
  <!-- Custom Home: InVadobay -->
  <invadobay-view
    v-if="custom_home_invadobay_slug && is_authenticated()"
    :slug="custom_home_invadobay_slug"
    :is_custom_home="true"
  />

  <!-- Homepage Standard -->
  <homepage v-else @search="reset_search_state">
    <invadobays v-if="is_authenticated()" />
  </homepage>
</template>

<script>
  import { mapState } from 'vuex';
  import { get_config } from '@src/utilities';
  import Homepage from '@/components/views/homepage.vue';
  import Invadobays from '@liveeps/components/blocks/invadobay/invadobays.vue';
  import InvadobayView from '@liveeps/components/views/invadobay.vue';

  export default {
    name: 'homepage-view',

    components: {
      homepage: Homepage,
      invadobays: Invadobays,
      'invadobay-view': InvadobayView,
    },

    computed: {
      ...mapState('liveeps', ['selected_invadobay']),
      custom_home_invadobay_slug() {
        const homepage = get_config('guiSettings.customizations.homepage');
        if (!homepage || homepage.component !== 'in-vadobay') {
          return null;
        }
        const { slug } = homepage.props || {};
        return slug;
      },
    },

    created() {
      // clean up state on creation
      if (Object.keys(this.selected_invadobay).length > 0) {
        this.$store.commit('liveeps/selected_invadobay', {});
        this.$store.commit('liveeps/location', {
          label: '',
          latitude: '',
          longitude: '',
          matchLevel: '',
        });
      }
    },

    methods: {
      reset_search_state() {
        this.$store.commit('liveeps/selected_invadobay', {});
        this.$store.commit('liveeps/from_alternative_dates', false);
      },
    },
  };
</script>
